module.exports = __webpack_public_path__ + "static/media/FPSvertical.4591db6f.pdf";